import React from 'react'
import styled from 'styled-components'
import { BREAKPOINTS } from '@/components/ds/breakpoints'

const videoFragment = `
  streamingUrl
  mp4High: mp4Url(res: high)
  mp4Med: mp4Url(res: medium)
  mp4Low: mp4Url(res: low)
  duration
  framerate
  thumbJpg: thumbnailUrl(format: jpg)
  thumbPng: thumbnailUrl(format: png)
  thumbGif: thumbnailUrl(format: gif)
`

const fragment = `
  fragment VideoFullWidthBlockFragment on VideoFullWidthRecord {
    __typename
    id
    video {
      video {
        ${videoFragment}
      }
    }
  }

`

type VideoType = {
  video: {
    streamingUrl?: string
    mp4High: string
    mp4Med: string
    mp4Low: string
    duration: number
    framerate: number
    thumbJpg: string
    thumbPng: string
    thumbGif: string
  }
}

export type VideoFullWidthRecord = {
  id?: string
  video?: VideoType
}

const StyledVideoContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 1800px;
  overflow: hidden;
  margin: 0 auto;

  @media screen and (max-width: ${BREAKPOINTS.m}) {
    height: 590px;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    @media screen and (max-width: ${BREAKPOINTS.m}) {
      object-fit: cover;
    }
    @media screen and (min-width: 1800px) {
      border-radius: var(--radius-24);
    }
  }
`

export const VideoFullWidthBlock = ({ record }: { record: VideoFullWidthRecord }) => {
  return (
    <StyledVideoContainer>
      <video id="loop" preload="auto" playsInline autoPlay loop muted poster={record?.video?.video.thumbPng}>
        <source src={record?.video?.video.mp4High} />
      </video>
    </StyledVideoContainer>
  )
}

VideoFullWidthBlock.fragment = fragment
VideoFullWidthBlock.recordName = 'VideoFullWidthRecord'
